const targetNode = document.querySelector("input[name='id']");

// Options for the observer (which mutations to observe)
const config = { attributes: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    console.log(
      `The ${mutation.attributeName} attribute was modified. to ${targetNode.value}`
    );
  }
  let infos = JSON.parse(
    document.querySelector(".shopify-product-form noscript").textContent
  );
  let input = document.querySelector("input[name='quantity']");
  let variantID = targetNode.value;

  if (infos != null && input != null && infos[variantID] != null) {
    input.setAttribute("max", infos[targetNode.value].qnt);
    input.value = 1;
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// only works in product page
if (targetNode) {
  observer.observe(targetNode, config);
}
